import { gql } from "@apollo/client";

export const GET_BRAND = gql(`
  query brand($id: String!) {
    brand(id: $id) {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      createdAt
      updatedAt
    }
  }
`);

export const GET_ALL_BRANDS = gql(`
  query brands {
    brands {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      createdAt
      updatedAt
    }
  }
`);
